export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-950 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20golden%20light%20streaks%20and%20soft%20film%20grain%20texture%2C%20elegant%20movie%20theater%20atmosphere%20with%20subtle%20lens%20flare%2C%20rich%20dark%20amber%20and%20deep%20charcoal%20tones%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20no%20text%2C%20abstract%20composition&width=1920&height=1080&seq=hero-bg-movie-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/85"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-400 whitespace-nowrap">
                每日更新 · 新片速递
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              无极电影网
              <span className="block text-primary-400 mt-1 md:mt-2">
                海量电影免费高清在线观看
              </span>
            </h1>

            <p className="font-heading text-base md:text-lg text-primary-300/80 mt-3 md:mt-4 font-medium">
              热门大片蓝光画质 · 极速播放不卡顿
            </p>

            <p className="mt-6 md:mt-8 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none">
              无极电影网汇聚全球最新最热电影资源，涵盖院线大片、经典佳片、独立电影等丰富类型。
              <br className="hidden sm:block" />
              每日实时更新新片速递，蓝光高清画质搭配极速播放引擎，无需等待缓冲，
              <br className="hidden sm:block" />
              即可畅享流畅观影体验。无论是最新上映的院线大片还是小众艺术电影，这里都有你想看的一切。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-movie-2-line text-primary-400 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg md:text-xl font-bold text-foreground-950 font-heading">30,000+</div>
                  <div className="text-xs text-foreground-500">部影片资源</div>
                </div>
              </div>
              <div className="w-px h-10 bg-foreground-950/10 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-500/15">
                  <i className="ri-flashlight-line text-accent-400 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg md:text-xl font-bold text-foreground-950 font-heading">蓝光极速</div>
                  <div className="text-xs text-foreground-500">高清不缓冲</div>
                </div>
              </div>
              <div className="w-px h-10 bg-foreground-950/10 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-calendar-check-line text-primary-400 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg md:text-xl font-bold text-foreground-950 font-heading">每日更新</div>
                  <div className="text-xs text-foreground-500">新片不断档</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold whitespace-nowrap rounded-full text-center cursor-pointer transition-all duration-200 bg-primary-500 text-foreground-950 hover:bg-primary-400 active:scale-95"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即观影
              </a>
              <a
                href="#updates"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium whitespace-nowrap rounded-full text-center cursor-pointer transition-all duration-200 border border-foreground-950/20 text-foreground-800 hover:bg-foreground-950/10 active:scale-95"
              >
                <i className="ri-fire-line mr-2"></i>
                查看新片
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 rounded-2xl bg-primary-500/5 blur-3xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-foreground-950/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20composition%20with%20warm%20golden%20and%20deep%20shadow%20tones%2C%20abstract%20film%20strips%20and%20projector%20light%20beams%2C%20elegant%20vintage%20cinema%20aesthetic%20with%20art%20deco%20elements%2C%20rich%20contrast%20between%20amber%20highlights%20and%20dark%20background%2C%20dramatic%20atmospheric%20lighting%2C%20no%20text%20no%20faces%20no%20recognizable%20characters%2C%20sophisticated%20film%20noir%20style&width=960&height=1280&seq=hero-poster-movie-02&orientation=portrait"
                  alt="无极电影网 - 海量电影高清在线观看"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 md:-bottom-4 md:-right-4 px-3 py-2 md:px-4 md:py-2.5 rounded-xl bg-background-950/90 backdrop-blur border border-primary-500/20">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
                  <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap font-medium">
                    今日已更新 28 部新片
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}